// test2688
(2688 && 0);
